import Vue from 'vue'

export const logout = () => {
  Vue.prototype.$keycloak.logoutFn()
}

export const fetchWithToken = (url, options = {}) => {
  const keycloak = Vue.prototype.$keycloak
  const isFormDataBody = options.body instanceof FormData

  const doFetch = () => {
    const baseHeaders = Object.assign({}, options.headers, {
      Authorization: `Bearer ${keycloak.token}`,
    })
    const headers = isFormDataBody
      ? baseHeaders
      : Object.assign({}, baseHeaders, { 'Content-Type': 'application/json' })
    return fetch(url, Object.assign({}, options, { headers }))
  }

  if (keycloak && typeof keycloak.updateToken === 'function') {
    return new Promise((resolve) => {
      keycloak.updateToken(30)
        .success(() => resolve())
        .error(() => resolve())
    }).then(() => doFetch())
  }

  return doFetch()
}

export const getUserProfile = () => new Promise((resolve, reject) => {
  Vue.prototype.$keycloak.loadUserProfile().success((profile) => {
    resolve(profile)
  }).error((error) => {
    reject(error)
  })
})